export const common = {
  emptyValue: '--',
};
